import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { SessionProvider } from '@/features/auth/session';
import { useThemeBridge } from './theme';
import { ToastHost } from '@/components/ToastHost';
import { createQueryClient } from '@liniya/client-core';
import { ErrorBoundary } from './ErrorBoundary';

export function AppProviders({ children }: { children: ReactNode }) {
  // Created once per mount rather than at module scope, so tests can render
  // the tree repeatedly without inheriting another test's cache.
  const [queryClient] = useState(createQueryClient);
  useThemeBridge();

  return (
    <ErrorBoundary area="root">
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          {children}
          <ToastHost />
        </SessionProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
